'use client';

import Link from 'next/link';
import { motion } from 'framer-motion';

export default function ProcessSection() {
  return (
    <motion.section
      id="process"
      className="w-full py-24 sm:py-32"
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      viewport={{ once: true, amount: 0.5 }}
      transition={{ duration: 0.8 }}
    >
      <div className="max-w-3xl mx-auto text-center">
        <h2 className="text-4xl font-bold text-white">My Product Philosophy</h2>
        <p className="mt-6 text-lg text-text-primary leading-loose">
          I believe the best products emerge from a deep understanding of the user's problem, combined with a practical knowledge of what it takes to build a robust solution. My approach is to own the product lifecycle—from the initial 'why' to the final 'how'.
          <br /><br />
          This allows me to lead with empathy for the user while maintaining a clear, pragmatic dialogue with engineering. My goal is always the same: to ensure we not only build the thing right, but that we are building the right thing.
        </p>
      </div>
    </motion.section>
  );
}
